import setStyleOverride from './setStyleOverride';
import addLayerOverride from './addLayerOverride';
import CUSTOM_EVENTS from 'Map/utils/events/customEvents';

const tranformEventName = (eventName) => eventName === 'load' ? CUSTOM_EVENTS.MAP_LOAD : eventName;

export const overriddenMethods = {
    addLayer: addLayerOverride.addLayer,
    setStyle: setStyleOverride.setStyle,
    once(eventName, callback) {
        this.__om.once(tranformEventName(eventName), callback);
        return this;
    },
    on(eventName, ...args) {
        this.__om.on(tranformEventName(eventName), ...args);
        return this;
    },
    off(eventName, ...args) {
        this.__om.off(tranformEventName(eventName), ...args);
        return this;
    }
};



// WEBPACK FOOTER //
// ./map/map/mapboxOverriddenMethods/overriddenMethods.js